module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/offer-icon-3e6dbe7d126278b058565ee829c81045.png";